import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { StyledDashboardDangerIcon, StyledDashboardErrorBlock } from "./Styled";

interface IDashboardErrorBlock {
    title: string;
}

export const DashboardErrorBlock: FC<IDashboardErrorBlock> = ({ title }) => {
    return (
        <StyledDashboardErrorBlock>
            <StyledDashboardDangerIcon />
            <PrimaryText>{title}</PrimaryText>
        </StyledDashboardErrorBlock>
    );
};
